import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0bef0e0f&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0bef0e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef0e0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bef0e0f')) {
      api.createRecord('0bef0e0f', component.options)
    } else {
      api.reload('0bef0e0f', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0bef0e0f&scoped=true&", function () {
      api.rerender('0bef0e0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28bm7pFb5xAJg/JS/comp/PopupBox.vue"
export default component.exports